export const AsgFWP = new Proxy({}, {
    get(_, prop) {
        if (typeof AsgFW === 'object' && AsgFW !== null) {
            const origMethod = AsgFW[prop];
            if (typeof origMethod === 'function') {
                return (...args) => origMethod.apply(AsgFW, args);
            }
            return undefined;
        } else {
            console.warn(`AsgFW is not available yet. Cannot call ${prop}`);
            return () => {}; // noop function
        }
    }
});
